import { UPLOAD_STATUS } from "./upload/DocumentUpload";

export const anyUploadInProgress = (documents) =>
  documents && documents.filter((doc) => doc.uploadStatus === UPLOAD_STATUS.IN_PROGRESS).length > 0;

export const minDocumentsAttached = (documents, minDocumentsAttached) =>
  documents &&
  minDocumentsAttached !== null &&
  minDocumentsAttached !== undefined &&
  documents.filter((doc) => doc.required && doc.uploadStatus === UPLOAD_STATUS.SUCCESS).length >=
    minDocumentsAttached;

export const consentsAccepted = (consents) =>
  consents && consents.filter((consent) => !consent.accepted).length === 0;

export const allowedFileSize = (sizeInBytes, max) => {
  try {
    let fileSizeInMb = (sizeInBytes / 1000000).toFixed(2);
    return max >= fileSizeInMb;
  } catch (error) {
    return false;
  }
};
